import { useState } from "react";
import { Button, Input } from "semantic-ui-react";
import { RedirectIfLoggedIn } from "../Login/RedirectIfLoggedIn";
import { ReactComponent as Logo } from "../../icons/Logo text_vertical.svg";
import { ReactComponent as BMIMILogo } from "../../icons/BMIMI_Logo_srgb.svg";
import { forgotPassword } from "../../api/users";
import { useIntl } from "react-intl";
import { Link } from "react-router-dom";
import "../Login/Login.css";

export const ForgotPassword = () => {
    const intl = useIntl();
    const [username, setUsername] = useState("");
    const [success, setSuccess] = useState(false);
    const [sendingRequest, setSendingRequest] = useState(false);
    const [error, setError] = useState("");
    const disabled = username.length === 0 || sendingRequest;

    const handleSendForgotPassword = async () => {
        setError("");
        setSendingRequest(true);
        try {
            await forgotPassword(username);
            setSuccess(true);
        } catch {
            setError(intl.formatMessage({ id: "sendForgotPasswordEmailFail" }));
        } finally {
            setSendingRequest(false);
        }
    };

    return (
        <div className="login-container">
            <RedirectIfLoggedIn />
            <div className="login-wrapper">
                <div className="center-login-container">
                    <section className="left-container">
                        <div className="upper-container"></div>
                        <div className="lower-container"></div>
                        <Logo title="" />
                    </section>
                    <section className="login-form-container">
                        {success ? (
                            <>
                                <p>{intl.formatMessage({ id: "weHaveSentEmail" })}</p>
                                <Button
                                    fluid
                                    primary
                                    as={Link}
                                    to="/login"
                                    content={intl.formatMessage({ id: "backToLogin" })}
                                />
                            </>
                        ) : (
                            <>
                                <h2 id="centered-text">
                                    {intl.formatMessage({ id: "forgotPassword" })}
                                </h2>
                                <p>{intl.formatMessage({ id: "typeInYourEmail" })}</p>
                                <Input
                                    id="username"
                                    value={username}
                                    onChange={(e: any) => setUsername(e.target.value)}
                                />
                                <hr />
                                <Button
                                    fluid
                                    primary
                                    loading={sendingRequest}
                                    disabled={disabled}
                                    content={intl.formatMessage({ id: "sendPasswordResetEmail" })}
                                    onClick={handleSendForgotPassword}
                                />
                                {!!error && <p id="login-error-message">{error}</p>}
                            </>
                        )}
                    </section>
                </div>
                <BMIMILogo title="" />
            </div>
        </div>
    );
};
